import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { Loader2 } from "lucide-react";
import { useProfile } from "@/hooks/useProfile";
import { useHealthSync } from "@/hooks/useHealthSync";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user, loading } = useAuth();
  const { profile, loading: profileLoading } = useProfile();
  const location = useLocation();
  useHealthSync(user?.id ?? null);

  if (loading || profileLoading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="flex items-center gap-2 text-foreground">
          <Loader2 className="h-6 w-6 animate-spin" />
          <span>Loading...</span>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  const isOnboardingRoute = location.pathname === "/onboarding";
  const isTutorialRoute = location.pathname === "/tutorial";
  const onboardingCompleted = profile?.onboarding_completed === true;
  const needsOnboarding = !onboardingCompleted;
  const tutorialCompletedLocalRaw = localStorage.getItem('tutorial_completed');
  const tutorialCompleted = tutorialCompletedLocalRaw === 'true' || (tutorialCompletedLocalRaw === null && (profile?.tutorial_completed ?? false));

  // Redirect from onboarding if already completed
  if (isOnboardingRoute && onboardingCompleted) {
    return <Navigate to="/dashboard" replace />;
  }

  // Redirect to onboarding if not completed
  if (!isOnboardingRoute && !isTutorialRoute && needsOnboarding) {
    return <Navigate to="/onboarding" replace />;
  }

  // Redirect from tutorial if already completed
  if (isTutorialRoute && tutorialCompleted) {
    return <Navigate to="/dashboard" replace />;
  }


  return <>{children}</>;
};